export default __webpack_public_path__ + "static/media/empty_campaigns.b47b9a63.png";